import { ConsoleRequest, DataProviderType } from 'apps/webcomponents/src/utils/request';
import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { GetAccessTokenResponse, GetServerUrlResponse, IntegrationContainerImageScannerWebComponentSchema } from '../types';

export class IntegrationContainerImageScannerBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<IntegrationContainerImageScannerWebComponentSchema> {
    throw new Error('Not implemented');
  }

  public async getAccessToken(companyId: string): Promise<GetAccessTokenResponse> {
    return await ConsoleRequest.createRequest<GetAccessTokenResponse>({
      dataProviderType: DataProviderType.INTEGRATION,
      endpoint: 'IntegrationsCnapp',
      method: 'generateAccessToken',
      payload: { companyId: companyId },
    });
  }

  public async getServerUrl(): Promise<GetServerUrlResponse> {
    return await ConsoleRequest.createRequest<GetServerUrlResponse>({
      dataProviderType: DataProviderType.INTEGRATION,
      endpoint: 'IntegrationsCnapp',
      method: 'fetchServerUrl',
    });
  }
}
